<template>
  <div class="main">
    <div class="content-box">
      <div class="box-title">区域分布</div>
      <div class="map"></div>
    </div>
    <div class="content-box2">
      <div class="box-title">
        <span>土地养分状况分析</span>
        <div class="title-right">
          <el-radio-group v-model="tabPosition" @change="change">
            <el-radio-button v-for="item,index in initRadios" :label="item" :key="index">{{item}}</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="rightechart">
        <component :is="userAsset" :data="echartData"></component>
      </div>

    </div>
  </div>
</template>

<script type="text/javascript" scoped>
  import Analysisaxis from '../../components/echarts/qualityAnalysisaxis.vue'
  import Analysistime from '../../components/echarts/qualityAnalysistime.vue'
  export default {
    data() {
      return {
        userAsset:'Analysistime',
        tabPosition: '时间',
        initRadios: ['时间', '区域'],
        echartData: {}
      }
    },
    methods: {
      change(val) {
        if(val=="时间") {
          this.userAsset="Analysistime";
        }
        else {
          this.userAsset="Analysisaxis";
        }
      }
    },
    components: {
      Analysisaxis,
      Analysistime
    }
  }
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    height: 433px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content-box {
      width: calc((100% - 20px) / 2);
      height: 100%;
      box-sizing: border-box;
      background-color: #002624;
      border: solid 1px rgba(0, 255, 238, 0.5);
      .box-title {
        height: 30px;
        padding-left: 12px;
        line-height: 30px;
        background-image: linear-gradient(79deg, rgba(0, 255, 238, 0.5) 0%, rgba(0, 243, 247, 0.4) 25%, rgba(0, 230, 255, 0.3) 50%, rgba(0, 230, 255, 0.1) 100%);
        background-blend-mode: normal, normal;
      }
      .map {
        background: url('../../../static/img/areaspread.png') no-repeat;
        width: 100%;
        height: calc(100% - 30px);
        background-size: 100% 100%;

      }
    }
    .content-box2 {
      width: calc((100% - 20px) / 2);
      height: 100%;
      box-sizing: border-box;
      background-color: #002624;
      border: solid 1px rgba(0, 255, 238, 0.5);
      .box-title {
        height: 30px;
        padding-left: 12px;
        background-image: linear-gradient(79deg, rgba(0, 255, 238, 0.5) 0%, rgba(0, 243, 247, 0.4) 25%, rgba(0, 230, 255, 0.3) 50%, rgba(0, 230, 255, 0.1) 100%);
        background-blend-mode: normal, normal;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title-right {
          display: inline-block;
          /*float: right;*/
          margin-right: 10px;
          // margin-top: -4px;
        }
        .title-right /deep/ .el-radio-group {
          background-color: #071210;
          border-radius: 11px;
          border: solid 1px rgba(0, 248, 153, 0.3);
        }

        .title-right /deep/ .el-radio-button__inner {
          height: 20px;
          padding: 4px 20px;
        }

        .title-right /deep/ .el-radio-button .el-radio-button__inner {
          background: #002624;
          border-color: rgba(0, 248, 153, 0.3);
        }

        .title-right /deep/ .el-radio-button.is-active .el-radio-button__inner {
          background: #009288;
        }

        .title-right /deep/ .el-radio-button .el-radio-button__inner {
          color: #a4cabd;
        }

        .title-right /deep/ .el-radio-button.is-active .el-radio-button__inner {
          color: #ffffff;
        }

        .title-right /deep/ .el-radio-button:focus {
          box-shadow: 0 0 1px 1px rgba(0, 248, 153, 0.3);
        }

        .title-right /deep/ .el-radio-button:first-child .el-radio-button__inner, .title-right /deep/ .el-radio-button:first-child:focus {
          border-top-left-radius: 11px;
          border-bottom-left-radius: 11px;
        }

        .title-right /deep/ .el-radio-button:first-child .el-radio-button__inner {
          border-left: none;
        }

        .title-right /deep/ .el-radio-button .el-radio-button__inner {
          line-height: 11px;
        }

        .title-right /deep/ .el-radio-button:last-child .el-radio-button__inner, .title-right /deep/ .el-radio-button:last-child:focus {
          border-top-right-radius: 11px;
          border-bottom-right-radius: 11px;
        }
      }
      .rightechart {
        box-sizing: border-box;
        position: relative;
        width: 100%;
        height: calc(100% - 30px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/quality/soil.vue